import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import PageView from './components/PageView.jsx';
import { initAnalytics } from './lib/analytics.js';
import './index.css';

initAnalytics();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <PageView />
      <App />
    </BrowserRouter>
  </StrictMode>
);
